/**
 * Opens popup centered
 *
 * @see https://stackoverflow.com/a/16861050
 */
export const openCenteredPopup = (
  url = "",
  title = "VNC Live",
  w = 800,
  h = 800
) => {
  // Fixes dual-screen position                            Most browsers      Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement && document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement && document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : screen.height;

  const left = width / 2 - w / 2 + dualScreenLeft;
  const top = height / 2 - h / 2 + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${w},height=${h},top=${top},left=${left}`
  );

  // Puts focus on the newWindow
  if (newWindow && window.focus) {
    newWindow.focus();
  }
};
